import { dossierMachine, findTransition, type DossierRecord, type DossierStatus } from '@clim/domain';
import { useState } from 'react';
import { errorMessage } from '../lib/errors';
import { useEngine } from '../lib/session';
import { ErrorBox, Field, Modal, Select, Textarea } from './ui';

export function TransitionDialog({ dossier, to, onClose }: { dossier: DossierRecord; to: DossierStatus; onClose(): void }) {
  const engine = useEngine();
  const def = findTransition(dossierMachine, dossier.status, to, 'user');
  const reasons = engine
    .list('reason')
    .filter((r) => r.isActive && r.category === def?.reasonCategory)
    .sort((a, b) => a.sortOrder - b.sortOrder);
  const [reasonId, setReasonId] = useState('');
  const [comment, setComment] = useState('');
  const [error, setError] = useState<string | null>(null);
  const reason = reasons.find((r) => r.id === reasonId);
  const needsComment = def?.requiresComment || reason?.requiresComment;

  const submit = async () => {
    try {
      await engine.transitionDossier(dossier.id, to, { reasonId: reasonId || null, comment: comment || null });
      onClose();
    } catch (err) {
      setError(errorMessage(err));
    }
  };

  return (
    <Modal title={`Passer en « ${dossierMachine.labels[to]} »`} onClose={onClose}>
      <div className="form">
        {def?.reasonCategory && (
          <Field label="Motif">
            <Select value={reasonId} onChange={(e) => setReasonId(e.target.value)} autoFocus>
              <option value="">Choisir…</option>
              {reasons.map((r) => (
                <option key={r.id} value={r.id}>
                  {r.label}
                </option>
              ))}
            </Select>
          </Field>
        )}
        <Field label={needsComment ? 'Commentaire (obligatoire)' : 'Commentaire'}>
          <Textarea value={comment} onChange={(e) => setComment(e.target.value)} />
        </Field>
        <ErrorBox message={error} />
        <div className="actions">
          <button className="btn" onClick={onClose}>
            Annuler
          </button>
          <button className={`btn ${['cancelled', 'lost'].includes(to) ? 'danger' : 'primary'}`} onClick={() => void submit()}>
            Confirmer
          </button>
        </div>
      </div>
    </Modal>
  );
}
